export const SHIFT_EVENT_FILTERS_WIDGET_NAMESPACE = 'widget.shift-event-filters'
